import { AllowedAccess } from 'react-permission-role';
import { useLocation, useParams } from 'react-router-dom';
import {Grid, Card, CardContent, Button} from '@mui/material'
import { Plus } from 'react-feather'

import { useFechInitLoanCalculator } from './hooks';
import { QuotationTable } from './QuotationTable';
import { QuotationForm } from './QuotationForm';

export const LoanCalculator = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitLoanCalculator({location, paramsURL})

  const {
    globalStates,
    Actions
  } = useFetchInit

  const {handleClickShowForm} = Actions
  const { showForm} = globalStates

  return (
    <AllowedAccess permissions={['159_COTIZADOR_DE_CREDITO']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        {(!showForm)&&(
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                  <CardContent >
                    <div className='h4 mt-1 mb-1'> Cotizador de Creditos </div>
                    <div className="border-bottom border-dark"></div>
        
                    <Button
                      startIcon={<Plus />}
                      size='medium'
                      type='button'
                      variant='contained'
                      color='primary'
                      sx={{ marginTop: 4 }}
                      onClick={() => handleClickShowForm('EDITABLE')}
                    >
                      Nueva Cotizacion
                    </Button>
        
                    <div className="pt-4"></div>
                    <QuotationTable 
                      useFetchInit={useFetchInit}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
        )}
        {(showForm) && (
          <QuotationForm useFetchInit={useFetchInit} />
        )}
      </div>
    </AllowedAccess>
  )
}
